import { whenPurposeConsented } from '@/Utils/PrivacyUtility';

/**
 * @param {object} pluginConfig
 * @param {string} pluginConfig.id - Hotjar site ID
 */
export default function hotjarPlugin(pluginConfig) {
    whenPurposeConsented('Analytics').then(() => {
        window.hj = window.hj || function() {
            (window.hj.q = window.hj.q || []).push(arguments);
        };
        window._hjSettings = { hjid: pluginConfig.id, hjsv: 6 };

        const script = document.createElement('script');
        script.async = true;
        script.src = `https://static.hotjar.com/c/hotjar-${window._hjSettings.hjid}.js?sv=${window._hjSettings.hjsv}`;
        document.head.appendChild(script);
    });

    return {
        name: 'hotjar',
        config: pluginConfig,
        track: () => {},
    };
}
